import { Check, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { AppCustomPropertyError } from "./AppCustomPropertyError";

type AppCustomPropertyRichProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyRich = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyRichProps) => {

    const [richText, setRichText] = useState<string>(data as string || "");

    useEffect(() => {
        onChange(customProperty.label, richText);
    }, [richText]);

    return (
        <div className="app-custom-property-rich">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                RTF editor here for {data}

                <AppCustomPropertyError 
                    flagRequired={validate && !richText && customProperty.required}
                />

                {/* <AppCustomPropertyError 
                    flagRequired={validate && !richText && customProperty.required}
                /> */}
                {/* {validate && !richText && customProperty.required &&
                    <div className="app-employee-record-error">
                       <Check size={16} color="red"/>
                    </div>
                } */}
            </div>
        </div>
    )
}
